import { ReactComponent as CircleOutline } from 'assets/icons/icon-circle-outline.svg';

export default CircleOutline;
